import { render, staticRenderFns } from "./DiameterDetail.vue?vue&type=template&id=ffeb98ce&"
import script from "./DiameterDetail.vue?vue&type=script&lang=js&"
export * from "./DiameterDetail.vue?vue&type=script&lang=js&"
import style0 from "./DiameterDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports